import PracticeAreaTemplate from '../../components/PracticeAreaTemplate';
import { usePracticeArea } from '../../hooks/usePracticeArea';

export default function DisputesPage() {
  const pa = usePracticeArea('disputes');
  return <PracticeAreaTemplate pa={pa} />;
}
